module.exports = __webpack_public_path__ + "img/package-active.fa76c50a.png";